import { useRef, useEffect } from "react";
import { C } from "../tokens";

export default function Cursor() {
  const dot  = useRef(null);
  const ring = useRef(null);
  const pos  = useRef({ x: 0, y: 0 });
  const ring_pos = useRef({ x: 0, y: 0 });
  const raf  = useRef(null);
  const currentColor = useRef(C.crimson);
  const hovering = useRef(false);

  useEffect(() => {
    const move = e => { pos.current = { x: e.clientX, y: e.clientY }; };
    window.addEventListener("mousemove", move);

    const getSectionColor = () => {
      if (!document.elementFromPoint) return C.crimson;
      const el = document.elementFromPoint(pos.current.x, pos.current.y);
      if (!el) return C.crimson;
      const section = el.closest("[data-cursor-color]");
      return section ? section.getAttribute("data-cursor-color") : C.crimson;
    };

    const applyColor = (color) => {
      if (color === currentColor.current) return;
      currentColor.current = color;
      if (dot.current && !hovering.current) dot.current.style.background = color;
      if (ring.current) ring.current.style.borderColor = color;
    };

    const animate = () => {
      if (dot.current) {
        dot.current.style.left  = pos.current.x + "px";
        dot.current.style.top   = pos.current.y + "px";
      }
      if (ring.current) {
        ring_pos.current.x += (pos.current.x - ring_pos.current.x) * 0.12;
        ring_pos.current.y += (pos.current.y - ring_pos.current.y) * 0.12;
        ring.current.style.left = ring_pos.current.x + "px";
        ring.current.style.top  = ring_pos.current.y + "px";
      }
      applyColor(getSectionColor());
      raf.current = requestAnimationFrame(animate);
    };
    raf.current = requestAnimationFrame(animate);

    const grow = () => { hovering.current = true; const hoverColor = currentColor.current === C.gold ? C.crimson : C.gold; if(dot.current){dot.current.style.width="18px";dot.current.style.height="18px";dot.current.style.background=hoverColor;} if(ring.current){ring.current.style.width="52px";ring.current.style.height="52px";} };
    const shrink = () => { hovering.current = false; if(dot.current){dot.current.style.width="10px";dot.current.style.height="10px";dot.current.style.background=currentColor.current;} if(ring.current){ring.current.style.width="36px";ring.current.style.height="36px";} };
    // Delegated so elements added after mount (route changes, async lists) still trigger hover.
    const over = e => { if (e.target.closest("a,button,[data-hover]")) grow(); };
    const out = e => { const el = e.target.closest("a,button,[data-hover]"); if (el && !el.contains(e.relatedTarget)) shrink(); };
    document.addEventListener("mouseover", over, { passive: true });
    document.addEventListener("mouseout", out, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <>
      <div id="cursor-dot"  ref={dot}/>
      <div id="cursor-ring" ref={ring}/>
    </>
  );
}
